import Vue from 'vue'

const UPDATE_WEBSITE_CONFIG = (state, config) => {
  config.vanity_url = window.location.hostname !== process.env.PLATFORM_HOST
  state.websiteConfig = config
}

const UPDATE_LOGIN_STATUS = (state, status) => {
  state.loggedIn = status
}

const UPDATE_PARTICIPANT = (state, participant) => {
  state.participant = participant
}

const UPDATE_PROGRAMS = (state, programs) => {
  state.programs = programs
}

const UPDATE_PROGRAM_DASHBOARD = (state, programDashboard) => {
  state.programDashboard = programDashboard
}

const UPDATE_DASHBOARD = (state, dashboard) => {
  state.dashboardLayout = dashboard.dashboard_layout
}

const UPDATE_PROGRAM_DETAILS = (state, program) => {
  state.programDetails[program.id] = program
}

const DELETE_PROGRAM_DETAILS = (state, programId) => {
  state.programDetails[programId] = null
}

const UPDATE_PAGE_DETAILS = (state, page) => {
  state.pageDetails[page.id] = page
}

const UPDATE_PLATFORM_POINT_CAP_DETAILS = (state, pointCap) => {
  state.platformPointCap = pointCap
}

const UPDATE_CARD_DETAILS = (state, card) => {
  Vue.set(state.cards, card.id, card)
}

const UPDATE_POINTS = (state, data) => {
  state.points = data.points
  state.participant.points_balance = data.points_balance
}

const UPDATE_REWARD_FILTERS = (state, data) => {
  state.rewardFilters = data.result
}

const UPDATE_CATEGORIES = (state, categories) => {
  state.categories = categories
}

const UPDATE_CATEGORY_DETAIL = (state, categoryDetails) => {
  state.categoryDetails = categoryDetails.result
}

const UPDATE_REWARDS = (state, rewards) => {
  Vue.set(state, 'rewards', {
    items: rewards.result.items,
    pagination: rewards.pagination
  })
}

const UPDATE_PRODUCT_DETAIL = (state, reward) => {
  state.rewardDetails = reward
}

const UPDATE_PRODUCT_SAVEDREWARD_ID = (state, id) => {
  state.rewardDetails.saved_reward_id = id
}

const UPDATE_PARTICIPANT_SETUP = (state, participant) => {
  state.participantSetup = participant
}

const UPDATE_APPROVER_CLAIMS = (state, response) => {
  state.approverClaims = response.data
}

const UPDATE_APPROVER_CLAIM = (state, claim) => {
  let claimFound = false
  for (let i = 0; i < state.approverClaims.length; i++) {
    if (state.approverClaims[i].id === claim.id) {
      Vue.set(state.approverClaims, i, claim)
      claimFound = true
    }
  }
  if (!claimFound) {
    state.approverClaims.push(claim)
  }
}

const UPDATE_SUBMITTER_CLAIMS = (state, response) => {
  state.submitterClaims = response.data
}

const UPDATE_SUBMITTER_CLAIM = (state, claim) => {
  let claimFound = false
  for (let i = 0; i < state.submitterClaims.length; i++) {
    if (state.submitterClaims[i].id === claim.id) {
      Vue.set(state.submitterClaims, i, claim)
      claimFound = true
    }
  }
  if (!claimFound) {
    state.submitterClaims.push(claim)
  }
}

const UPDATE_REPORT_DATA = (state, card) => {
  Vue.set(state.reportData, card.report_id, card.records)
}

const UPDATE_CHART_DATA = (state, card) => {
  Vue.set(state.chartData, card.id, card.chart)
}

const UPDATE_CLAIM_MODAL_DATA = (state, claim) => {
  state.claimModalData = claim
}

const UPDATE_CLAIM_MODAL_SHOW = (state, show) => {
  state.claimModalShow = show
}

const UPDATE_CLAIM_MODAL_MESSAGE = (state, message) => {
  state.claimModalMessage = message
}

const UPDATE_CLAIM_MODAL_TYPE = (state, type) => {
  state.claimModalType = type
}

const WITHDRAW_CLAIM = (state, id) => {
  for (let i = 0; i < state.submitterClaims.length; i++) {
    if (state.submitterClaims[i].id === id) {
      state.submitterClaims.splice(i, 1)
    }
  }
}

const UPDATE_PROGRAM_IMAGES = (state, images) => {
  Vue.set(state.websiteConfig, 'program_images', images)
}

const UPDATE_SAVED_REWARDS = (state, savedRewards) => {
  state.savedRewards = savedRewards
}

const DELETE_SAVED_REWARD = (state, id) => {
  for (let i = 0; i < state.savedRewards.length; i++) {
    if (state.savedRewards[i].id === id) {
      state.savedRewards.splice(i, 1)
    }
  }
}

const UPDATE_SAVED_REWARD = (state, reward) => {
  let rewardFound = false
  for (let i = 0; i < state.savedRewards.length; i++) {
    if (state.savedRewards[i].id === reward.id) {
      Vue.set(state.savedRewards, i, reward)
      rewardFound = true
    }
  }
  if (!rewardFound) {
    state.savedRewards.push(reward)
  }
}

const UPDATE_LEADERBOARD_MODAL_DATA = (state, card) => {
  state.leaderboardModalData = card
}

const UPDATE_LEADERBOARD_MODAL_SHOW = (state, show) => {
  state.leaderboardModalShow = show
}

export {
  UPDATE_WEBSITE_CONFIG,
  UPDATE_LOGIN_STATUS,
  UPDATE_PARTICIPANT,
  UPDATE_DASHBOARD,
  UPDATE_PROGRAMS,
  UPDATE_PROGRAM_DETAILS,
  DELETE_PROGRAM_DETAILS,
  UPDATE_PROGRAM_DASHBOARD,
  UPDATE_PAGE_DETAILS,
  UPDATE_CARD_DETAILS,
  UPDATE_POINTS,
  UPDATE_REWARD_FILTERS,
  UPDATE_CATEGORIES,
  UPDATE_CATEGORY_DETAIL,
  UPDATE_REWARDS,
  UPDATE_PRODUCT_DETAIL,
  UPDATE_PRODUCT_SAVEDREWARD_ID,
  UPDATE_PARTICIPANT_SETUP,
  UPDATE_APPROVER_CLAIMS,
  UPDATE_APPROVER_CLAIM,
  UPDATE_SUBMITTER_CLAIMS,
  UPDATE_SUBMITTER_CLAIM,
  UPDATE_REPORT_DATA,
  UPDATE_CLAIM_MODAL_DATA,
  UPDATE_CLAIM_MODAL_SHOW,
  UPDATE_CLAIM_MODAL_TYPE,
  UPDATE_CLAIM_MODAL_MESSAGE,
  UPDATE_PROGRAM_IMAGES,
  WITHDRAW_CLAIM,
  UPDATE_SAVED_REWARDS,
  DELETE_SAVED_REWARD,
  UPDATE_SAVED_REWARD,
  UPDATE_LEADERBOARD_MODAL_DATA,
  UPDATE_LEADERBOARD_MODAL_SHOW,
  UPDATE_CHART_DATA,
  UPDATE_PLATFORM_POINT_CAP_DETAILS
}



// WEBPACK FOOTER //
// ./src/store/mutations.js